<template>
  <div class="block">
    <el-select v-model="dataValue" placeholder="请选择" clearable @change="selecDate" class="selectWord">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item"
        >
      </el-option>
    </el-select>
      <el-date-picker
      class="date-picker"
      v-model="value"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      @change="dataSearch"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
	:default-time="['00:00:00', '23:59:59']"
      v-if="hackReset"
      align="right">
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: 0,
      options: [{
        value: '最近一周',
        label: '最近一周'
      }, {
        value: '最近一月',
        label: '最近一月'
      }, {
        value: '最近三月',
        label: '最近三月'
      }],
      value: [],
      dataValue: '',
      hackReset: true,
      selectValue: [],
    };
  },
  filters: {
    timestampToTime(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate()<10?'0'+(date.getDate()):date.getDate()) + ' ';
      var h = (date.getHours()<10?'0'+(date.getHours()):date.getHours())+ ':';
      var m = (date.getMinutes()<10?'0'+(date.getMinutes()):date.getMinutes()) + ':';
      var s = (date.getSeconds()<10?'0'+(date.getSeconds()):date.getSeconds());
      return Y + M + D + h + m + s;
    }
  },
  methods: {
    //获取选中日期的值
    dataSearch(value) {
      this.$emit('dataSearch', value )
    },
    //快速定位日期
    selecDate(item){
      var endTe = this.$options.filters['timestampToTime'];
      this.dataValue = item.value
      const end = new Date()
      var start = new Date();
      var newStart = '';
      var newEnd = '';
      newEnd = endTe(end)
      if(item.value == '最近一周') {
        endTe(start.setTime(start.getTime() - 3600 * 1000 * 24 * 7));
        newStart = endTe(start)
        this.hackReset = false
      }else if(item.value == '最近一月') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        newStart = endTe(start)
        this.hackReset = false
      }else if(item.value == '最近三月'){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        newStart = endTe(start)
        this.hackReset = false
      }
		if(this.value==null){
				this.value = []
		}
      this.$set(this.value, "0", newStart)
      this.$set(this.value, "1", newEnd)
      this.$emit('dataSearch', this.value )
      this.$nextTick(() => {
        this.hackReset = true
        this.$emit('pick', [newStart, newEnd]);
      });
    }
  }
};
</script>
<style scoped lang="stylus">
  .date-picker
    margin-left: 10px
    width: 360px
  .selectWord
    width: 120px
  .block
    height: 36px
  /deep/.el-date-editor .el-range-separator
    line-height: 28px
</style>